import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ToolButton, PopOut } from '@ibinder/ui-common-core';
import { plus, ellipsisMenu } from '@ibinder/common-icons';

import { printApiRestClient } from '../../api/rest.configuration';

import { ProvidersList } from './components/ProvidersList';
import {
  StyledActionbar,
  ActionbarContent,
  PopOutContainer,
  PopupButton
} from './PrintProviders.styles';

export const PrintProviders = () => {
  const navigate = useNavigate();
  const Actions = {
    addPrintProvider: 'Add print provider'
  };

  const addPrintProvider = () => {
    const url = `${location.pathname}/provider/add`;
    navigate(url.replace('//', '/'));
  };

  const onActionSelect = (action) => {
    if (action === Actions.addPrintProvider) {
      addPrintProvider();
    }
  };

  return (
    <>
      <StyledActionbar makeSticky={false}>
        <ActionbarContent>
          <ToolButton onClick={addPrintProvider} type="button">
            {plus} <span>{Actions.addPrintProvider}</span>
          </ToolButton>
          <PopOutContainer>
            <PopOut
              button={(ref, toggle) => (
                <ToolButton type="button" ref={ref} onClick={toggle}>
                  {ellipsisMenu}
                </ToolButton>
              )}
              item={(key, value) => (
                <>
                  <PopupButton onClick={() => addPrintProvider()}>
                    {plus}
                    <span>{value}</span>
                  </PopupButton>
                </>
              )}
              onSelect={onActionSelect}
              data={Actions}
              placement={'bottom-end'}
            />
          </PopOutContainer>
        </ActionbarContent>
      </StyledActionbar>
      <ProvidersList restClient={printApiRestClient} />
    </>
  );
};
